(() => {
  const init = (slider) => {
    if (slider.dataset.shineCategorySlider === 'ready') return;
    const track = slider.querySelector('.shine-category-slider__track');
    const pages = Array.from(slider.querySelectorAll('.shine-category-slider__page'));
    const previous = slider.querySelector('.shine-category-slider__control--prev');
    const next = slider.querySelector('.shine-category-slider__control--next');
    if (!track || !pages.length || !previous || !next) return;

    slider.dataset.shineCategorySlider = 'ready';
    let page = 0;
    const render = () => {
      track.style.transform = `translate3d(-${page * 100}%, 0, 0)`;
    };
    previous.addEventListener('click', () => {
      page = (page - 1 + pages.length) % pages.length;
      render();
    });
    next.addEventListener('click', () => {
      page = (page + 1) % pages.length;
      render();
    });
    render();
  };

  const bind = () => document.querySelectorAll('[data-shine-category-slider]').forEach(init);
  bind();
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();